exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".message-container-wrap[data-v-9f70f478]{width:100%;height:100%;padding:0 16px 0 16px;overflow:auto}.message-container-wrap .center[data-v-9f70f478]{text-align:center}.message-container-wrap .message-list[data-v-9f70f478]{padding-bottom:40px}", ""]);
